module.exports = __webpack_public_path__ + "img/cover.3bff9889.jpg";